/* eslint-disable import/prefer-default-export */
export const getNameString = (
  name: string,
  middleName: string | null | undefined,
  surname: string,
) => [name, middleName, surname].filter((it) => !!it).join(' ');
